// Six curated Scottish trails the founder personally recommends.
// Gamekeeper's notes are placeholder — replace with the founder's own words
// as they get ridden. Coordinates are approximate trailhead locations.

export const TRAILS_DATA = [
  {
    slug: 'glentress-forest',
    name: 'Glentress Forest',
    region: 'Peebles, Scottish Borders',
    coords: [55.6534, -3.1122],
    distance_km: 19,
    climb_m: 620,
    difficulty: 'Red',
    surface: 'Purpose-built singletrack',
    adaptiveFriendly: false,
    note:
      "One of the finest waymarked centres in Scotland — start on the blue if you're building confidence, work up to the red when you're feeling brave. Bike wash and a proper cafe at the trail head.",
    external:
      'https://www.google.com/maps/search/?api=1&query=Glentress+Forest+bike+trails',
  },
  {
    slug: 'ae-forest',
    name: 'Ae Forest',
    region: 'Dumfries & Galloway',
    coords: [55.2189, -3.6392],
    distance_km: 17,
    climb_m: 540,
    difficulty: 'Red',
    surface: 'Rocky forest track + singletrack',
    adaptiveFriendly: false,
    note:
      "Rougher than Glentress, more Highland feel. The Omega Man line has a couple of drops that'll get your heart going — go round if you're not sure. Bring proper mudguards after rain, the roots get slick.",
    external:
      'https://www.google.com/maps/search/?api=1&query=Ae+Forest+7stanes',
  },
  {
    slug: 'loch-lomond-loop',
    name: 'Loch Lomond West Shore',
    region: 'Loch Lomond & The Trossachs',
    coords: [56.1497, -4.6284],
    distance_km: 12,
    climb_m: 90,
    difficulty: 'Green',
    surface: 'Sealed cycle path',
    adaptiveFriendly: true,
    note:
      "The shoreline path from Balloch to Luss — flat, wide, sealed. Perfect for a step-through e-bike with waterproofs and wellies. Stop at the Village Rest at Luss for a proper flat white before turning back.",
    external:
      'https://www.google.com/maps/search/?api=1&query=Loch+Lomond+west+shore+cycle+path',
  },
  {
    slug: 'great-glen-way',
    name: 'Great Glen Way',
    region: 'Fort William → Inverness',
    coords: [56.9494, -5.1058],
    distance_km: 128,
    climb_m: 1850,
    difficulty: 'Blue',
    surface: 'Mixed gravel + towpath',
    adaptiveFriendly: false,
    note:
      "The classic Highland traverse — plan on 3-4 days with a properly-sized battery. Free bothies along the way for overnight kip, but book the ones near Fort Augustus in summer, they fill up.",
    external:
      'https://www.google.com/maps/search/?api=1&query=Great+Glen+Way+cycle',
  },
  {
    slug: 'devils-bathtub',
    name: "Devil's Bathtub",
    region: 'Moffat, Dumfries & Galloway',
    coords: [55.4172, -3.4406],
    distance_km: 24,
    climb_m: 780,
    difficulty: 'Blue',
    surface: 'Quiet tarmac + gravel spur',
    adaptiveFriendly: false,
    note:
      "A proper hill climb up an old drove road — cattle-thief country. The view from the top will humble you. Descent's on tarmac so mind the traffic on weekends.",
    external:
      'https://www.google.com/maps/search/?api=1&query=Devils+Bathtub+Moffat',
  },
  {
    slug: 'perthshire-estate-loop',
    name: 'Perthshire Estate Loop',
    region: 'Around Perth (private estate access)',
    coords: [56.3945, -3.4308],
    distance_km: 22,
    climb_m: 410,
    difficulty: 'Blue',
    surface: 'Estate track + farm road',
    adaptiveFriendly: true,
    note:
      "A gamekeeper's local — flat estate tracks with a couple of gentle climbs. Adaptive-friendly, especially the northern spur. Bring gaiters, the ticks are up between April and September. Slàinte at the estate cottage if it's open.",
    external:
      'https://www.google.com/maps/search/?api=1&query=Perthshire+cycling+trails',
  },
];

export const DIFFICULTY_COLOURS = {
  Green: '#4A7C25',
  Blue: '#2B5F9E',
  Red: '#B33A3A',
  Black: '#1A1A1A',
};
